import StatusError from './StatusError';

export default class Status500Error extends StatusError {}
